<style src="ant-design-vue/dist/antd.min.css"></style>
<style>
@import "./assets/css/animate.css";
</style>
<style lang="scss">
//TODO на ревью перенести старые стили почистить лишнее
@use "./assets/scss/_legacy/styles.scss";
@use "./assets/scss/index.scss";
</style>
<template>
  <div
    id="app"
    data-server-rendered="true"
    @click="bodyClick"
    :style="envSCSSvariables"
  >
    <div
      v-bind:class="{
        demo__AuthBlur: authModalStatus,
        demo__SubsBlur: subsModalStatus,
        demo__VerifyBlur: verifyModalStatus,
        ['__lang-' + currentLang]: true,
        ['__module-' + module]: true,
      }"
    >
      <Metrics />
      <template v-if="globalLoading">
        <div
          class="demo__PageLoading"
          :class="{ 'animated fadeOut': !postGlobalLoading }"
        >
          <a-spin size="large" />
        </div>
      </template>

      <a-config-provider :locale="locale">
        <router-view ref="page" />
      </a-config-provider>
      <!-- <DebugConsoleButton :console-messages="consoleMessages" /> -->
      <SupportButton v-if="showSupport" :user="user" />
      <Upload />
      <SubscriptionModal />
      <VerifyModal />
      <AuthModal />
      <BottomBanner
        v-if="showBottomAuthBanner"
        closeable="authBanner"
        :banner-text="$t($route.meta.authBannerText || 'Auth banner text')"
        :button-text="$t('Submit')"
        :button-action="() => {}"
        ym-location="banner"
      ></BottomBanner>
    </div>
    <Notification />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import locale_ru from "ant-design-vue/lib/locale/ru_RU";
import locale_en from "ant-design-vue/lib/locale/en_US";
import env from "API/index.js";
import Metrics from "Components/Metrics";
import * as Sentry from "@sentry/vue";
import { resetRouter } from "Router";
import SupportButton from "Components/SupportButton";
// import DebugConsoleButton from "Components/DebugConsoleButton";
import Upload from "Components/Upload";
import AuthModal from "Components/AuthModal";
import SubscriptionModal from "Components/SubscriptionModal";
import VerifyModal from "Components/VerifyModal";
import BottomBanner from "Components/BottomBanner";

import devtoolsDetect from "devtools-detect";

window.fff = devtoolsDetect;

import MobileDetect from "mobile-detect";

import subHooks from "./appMixins/subHooks";
import "intl-tel-input/build/css/intlTelInput.css";
const initialMD = new MobileDetect(window?.navigator.userAgent);

const os = initialMD?.os(),
  phone = initialMD?.phone(),
  tablet = initialMD?.tablet();
const osData = JSON.stringify(window?.navigator?.userAgentData || {});

if (!localStorage.getItem("osphtbldt")) {
  localStorage.setItem(
    "osphtbldt",
    JSON.stringify({ os, phone, tablet, osData })
  );
}

import Notification from "Components/Notification";
export default {
  mixins: [subHooks],
  components: {
    Metrics,
    SupportButton,
    Upload,
    AuthModal,
    BottomBanner,
    SubscriptionModal,
    Notification,
    VerifyModal,
    // DebugConsoleButton,
  },
  data() {
    return {
      servicesLoading: false,
      consoleMessages: [],
      editors: [],
      consoleInterval: undefined,
      locale_ru,
      resetRouter: resetRouter,
      locale_en,
      Sentry: Sentry,
      confirmMobileNotification: false,
      globalLoading: true,
      steps: [0, 1, 2],
      postGlobalLoading: true,
      user_update_interval: undefined,
      bodyclick_timeout: undefined,
      showMobileNoty: false,
    };
  },
  computed: {
    envSCSSvariables() {
      let style = {};
      Object.keys(process.env)
        .filter((key) => {
          return key.indexOf("SCSS") !== -1;
        })
        .map((key) => {
          style["--" + key.replaceAll("VUE_APP_SCSS_", "")] = process.env[key];
        });
      return style;
    },
    showBottomAuthBanner() {
      return (
        !this.user && this.$route.meta.showBottomAuthBanner && !this.isMobile
      );
    },
    onboardingCompleted() {
      return this.user ? this.user.onboardingCompleted : undefined;
    },
    locale() {
      return this["locale_" + this.$i18n.locale];
    },
    ...mapGetters([
      "api",
      "token",
      "services",
      "user",
      "MAX_TEXTURES_SIZE",
      "module",
      "modules",
      "windowWidth",
      "isMobile",
      "currentLang",
      "agent",
      "presets",
      "authModalStatus",
      "subsModalStatus",
      "verifyModalStatus",
      "userIsBaseSub",
      "isConsoleOpen",
      "userIsCorpSub",
      "subsPlans",
      "userLinks",
    ]),
    showSupport() {
      return process.env.VUE_APP_SHOW_SUPPORT === "on";
    },
  },
  watch: {
    isConsoleOpen(val) {
      this.$debug("КОНСОЛЬ: " + val, "error");
    },
    editors(editors) {
      this.$root.editors = editors;
    },
    $route(to, from) {
      if (
        this.user &&
        !this.user.userAgreementAcceptedAt &&
        this.$route.path !== "/user/agreement"
      ) {
        this.$router.push("/user/agreement");
        return;
      }
      if (
        !this.services.length ||
        from.path.split("/")[1] !== to.path.split("/")[1]
      ) {
        const newSelectedModule = this.$route.path.split("/")[1];

        if (
          !this.$_.findWhere(this.modules, { id: newSelectedModule }) &&
          !this.$route.meta.skipModuleCheck
        ) {
          let isFoundRouteForCurrentRedirect = false;
          this.$router.getRoutes().map((route) => {
            if (route.alias[0] === this.$route.path) {
              isFoundRouteForCurrentRedirect = true;
              this.$router.push(route.path);
            }
          });

          if (!isFoundRouteForCurrentRedirect) {
            this.$router.push("/");
          }

          return;
        }
        if (!this.$route.meta.skipModuleCheck) {
          this.$store.dispatch("updateModule", newSelectedModule);
        }

        this.getServices();
      }
    },
    confirmMobileNotification() {
      this.mobileNotyControl(1);
    },
    onboardingCompleted(val) {
      if (val !== undefined) {
        this.$debug(
          "ОНБОРДИНГ: изменен стейт onboardingCompleted: " + val,
          "warning"
        );
      }
    },
    user(val) {
      if (val && window.ym) {
        const app = this.agent
          ? {
              app: "app",
            }
          : {};
        const params = {
          auth: { user: val.username },
          MAX_TEXTURES_SIZE: this.MAX_TEXTURES_SIZE,
          ...app,
        };

        window.ym(process.env.VUE_APP_YA_METRIC, "params", params);

        this.$debug(
          `YA METRICS: передана инфа по ${val.username}, счетчик: ${process.env.VUE_APP_YA_METRIC}`
        );
      }
    },
    token(val) {
      if (val) {
        this.getUserInfo();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    clearInterval(this.consoleInterval);
  },
  // beforeCreate() {
  //   const self = this;
  //   window.addEventListener("error", (error) => {
  //     self.consoleMessages.push({
  //       type: "error",
  //       message: error.message,
  //       color: "#F44336",
  //     });
  //   });
  //   // Сохраняем оригинальные методы консоли
  //   const originalLog = window.console.log;
  //   const originalWarn = window.console.warn;
  //   const originalError = window.console.error;
  //   const originalInfo = window.console.info;

  //   // Перезаписываем методы консоли
  //   window.console.log = function (message) {
  //     self.consoleMessages.push({
  //       type: "log",
  //       message: message,
  //       arguments: arguments,
  //       color:
  //         arguments &&
  //         arguments[1] &&
  //         arguments[1].indexOf &&
  //         arguments[1].indexOf("color") !== -1
  //           ? arguments[1].replace("color:", "")
  //           : "white",
  //     });
  //     originalLog.apply(console, arguments); // Вызов оригинального метода
  //   };

  //   window.console.warn = function (message) {
  //     self.consoleMessages.push({
  //       type: "warn",
  //       message: message,
  //       color: "#FF9800",
  //     });
  //     originalWarn.apply(console, arguments); // Вызов оригинального метода
  //   };

  //   window.console.error = function (message) {
  //     self.consoleMessages.push({
  //       type: "error",
  //       message: message,
  //       color: "#F44336",
  //     });
  //     originalError.apply(console, arguments); // Вызов оригинального метода
  //   };

  //   window.console.info = function (message) {
  //     self.consoleMessages.push({
  //       type: "info",
  //       message: message,
  //       color: "#4CAF50",
  //     });
  //     originalInfo.apply(console, arguments); // Вызов оригинального метода
  //   };

  //   window.console.debug = function (message) {
  //     self.consoleMessages.push({
  //       type: "debug",
  //       message: message,
  //       color: "#9E9E9E",
  //     });
  //     originalInfo.apply(console, arguments); // Вызов оригинального метода
  //   };
  // },
  created() {
    this.consoleInterval = setInterval(this.detectConsole, 1000);
    this.$root.logoImg =
      "/imgs/logo_care_big__" + process.env.VUE_APP_INSTALLATION + ".svg";
    this.$root.showLogic = process.env.VUE_APP_ENABLE_SUBS === "on";
    this.getUserInfo();
    this.getServices();
    this.$accessModule("app", this);

    this.$root.editors = this.editors;
    this.$root.addEditor = this.addEditor;
    this.$root.removeEditor = this.removeEditor;

    this.$root.env = env;
    this.$root.getUserInfo = this.getUserInfo;
    this.$root.getSubs = this.getSubs;
    this.$root.finishOnboarding = this.finishOnboarding;
    this.$root.checkFinishOnboarding = this.checkFinishOnboarding;
    this.$root.getServices = this.getServices;
    this.$root.capitalizeFirstLetter = this.capitalizeFirstLetter;
    this.$root.rnd = this.rnd;
    this.$root.numWord = this.numWord;

    this.$root.$on("stopUserUpdate", () => {
      this.$debug("Автообновление данных юзера остановлено", "warning");
      clearInterval(this.user_update_interval);
    });
    this.$root.$on("startUserUpdate", this.startUserUpdate);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  mounted() {
    this.$store.dispatch(
      "updateIsConsoleOpen",
      window?.screen.height !==
        document?.getElementsByTagName("html")[0].offsetHeight
    );
    this.mobileNotyControl();
    this.afterRegisterControl();
  },
  methods: {
    getLastRegisteredForm() {
      const checkableRegFormData =
        window?.localStorage?.getItem("lastRegisteredForm");
      if (
        !!!checkableRegFormData ||
        checkableRegFormData?.indexOf("username") === -1
      )
        return;

      let lastRegisteredForm;

      try {
        lastRegisteredForm = JSON.parse(checkableRegFormData);
      } catch (error) {
        this.$debug(
          "Не удалось распарсить json форму после регистрации",
          "error",
          {
            error,
            lastRegisteredForm,
          }
        );
      }

      return lastRegisteredForm;
    },

    afterRegisterControl() {
      if (window?.location?.hash === "#login-after-register") {
        if (!this.token) {
          const form = this.getLastRegisteredForm();
          if (!form) {
            this.$store.dispatch("updateAuthModalStatus", "Login");
          } else {
            this.loginAfterRegister(form);
          }
        }
        this.$router.replace({ hash: "" });
        window?.localStorage?.removeItem("lastRegisteredForm");
      }
    },
    loginAfterRegister(form) {
      this.api
        .auth({
          data: {
            username: form.username,
            password: form.password,
          },
        })
        .then((response) => {
          if (response.data.token) {
            this.$store.dispatch("updateToken", response.data.token);
            this.$root.getUserInfo();
            this.$root.$emit("startUserUpdate");

            this.$debug("Успешная авторизация", "success", response.data);
          } else {
            throw response.data;
          }
        })
        .catch(() => {
          this.$store.dispatch("updateAuthModalStatus", "Login");
          this.$notify({
            group: "loggedIn",
            type: "error",
            text: this.$t("Auth error unknown"),
          });
        });
    },
    getHasLiedBrowser() {
      const md = new MobileDetect(window?.navigator.userAgent);
      return (
        os !== md.os() ||
        phone !== md.phone() ||
        tablet !== md.tablet() ||
        osData !== JSON.stringify(navigator.userAgentData) ||
        JSON.stringify({
          md: md.os(),
          phone: md.phone(),
          tablet: md.tablet(),
          osData: JSON.stringify(navigator.userAgentData),
        }) !== localStorage.getItem("osphtbldt")
      );
    },
    isTouchDevice() {
      var match = window.matchMedia || window.msMatchMedia;
      if (match) {
        var mq = match("(pointer:coarse)");
        return mq.matches;
      }
      return false;
    },
    isBrowserSimulation() {
      // maxTouchPoints is always = 1 on simulation mode
      return (
        this.isTouchDevice() && // https://stackoverflow.com/a/51774045/14238203
        navigator.maxTouchPoints === 1 &&
        // Alex solution finding 'mobile' in UA covers `getHasLiedBrowser` missing emulation on android devices
        this.getHasLiedBrowser()
      );
    },
    detectConsole() {
      this.$store.dispatch(
        "updateIsConsoleOpen",
        (devtoolsDetect.isOpen &&
          window?.navigator?.userAgent.indexOf("Mobile/") === -1) ||
          this.isBrowserSimulation()
      );
    },
    addEditor(data) {
      this.editors.push(data);
      this.$debug("MOBDOCEDITOR: добавили эдитор", "warning", data);
    },
    removeEditor(id) {
      const editor = this.$_.findWhere(this.editors, { id: id })?.editor;
      if (editor) {
        editor.destroy();
        this.editors = this.editors.filter((e) => {
          return e.id !== id;
        });
        this.$debug("MOBDOCEDITOR: уничтожили эдитор", "warning", editor);
      }
    },
    numWord(value, words) {
      value = Math.abs(value) % 100;
      var num = value % 10;
      if (value > 10 && value < 20) return value + " " + words[2];
      if (num > 1 && num < 5) return value + " " + words[1];
      if (num == 1) return value + " " + words[0];
      return value + " " + words[2];
    },
    rnd() {
      const gen = (min, max) =>
        max++ &&
        [...Array(max - min)].map((s, i) => String.fromCharCode(min + i));

      const sets = {
        num: gen(48, 57),
        alphaLower: gen(97, 122),
        alphaUpper: gen(65, 90),
      };

      function* iter(len, set) {
        if (set.length < 1) set = Object.values(sets).flat();
        for (let i = 0; i < len; i++)
          yield set[(Math.random() * set.length) | 0];
      }

      return Object.assign(
        (len, ...set) => [...iter(len, set.flat())].join(""),
        sets
      );
    },
    preloadServiceBg(service) {
      return this.$axios({
        url: service.backgroundImage,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const urlCreator = window.URL || window.webkitURL;
          // service.backgroundImageBinary = ;

          this.$store
            .dispatch("updateServiceBg", {
              service: service,
              backgroundImageBinary: urlCreator.createObjectURL(response.data),
            })
            .then(() => {
              this.$root.$emit("rerender");
            });
        })
        .catch(() => {
          this.$store
            .dispatch("updateServiceBg", {
              service: service,
              backgroundImageBinary: null,
            })
            .then(() => {
              this.$root.$emit("rerender");
            });
        });
    },
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
    },
    getServices() {
      if (this.servicesLoading) {
        return;
      }

      this.$store.dispatch("updateServices", []);
      this.$debug("Вызван список сервисов для модуля: " + this.module, "info");

      const apiForServicesList =
        this.api["get" + this.capitalizeFirstLetter(this.module) + "Services"];

      if (!apiForServicesList) {
        return;
      }

      this.servicesLoading = true;

      apiForServicesList()
        .then((response) => {
          response.data.map((service, index) => {
            service.id = service.service ? service.service.slug : service.id;

            // if (this.module === "AI") {
            //   const statusType = !index
            //     ? "free"
            //     : index === 1
            //     ? "price"
            //     : "subscription";
            //   service.status = {
            //     type: statusType,
            //     text: statusType === "price" ? "От 3 500 ₽" : undefined,
            //   };
            // }

            if (service.backgroundImage) {
              this.preloadServiceBg(service);
            }
          });
          this.$nextTick(() => {
            this.$store.dispatch("updateServices", response.data);
          });
          this.$debug(
            "Успешно получен список сервисов",
            "success",
            response.data
          );
        })
        // .catch((error) => {
        //   if (!this.services || this.services.length === 0) {
        //     this.$debug("Не удалось получить список сервисов", "error", error);
        //     this.$notify({
        //       group: "loggedIn",
        //       type: "error",
        //       text: this.$t("Services cannot loading"),
        //     });
        //   }
        // })
        .finally(() => {
          this.servicesLoading = false;
        });
    },

    mobileNotyControl(time) {
      setTimeout(
        () => {
          this.showMobileNoty =
            this.windowWidth < 992 && !this.confirmMobileNotification;
        },
        time ? time : 500
      );
    },
    checkFinishOnboarding() {
      const finishedAllSteps =
        this.steps.filter((step) => {
          return localStorage["step" + step + "_approve_" + this.user.username];
        }).length === this.steps.length;

      if (finishedAllSteps) {
        this.$debug(
          "На всех онбордингах нажали 'хорошо'. Завершение онбординга",
          "warning"
        );
        this.finishOnboarding();
      }
    },
    finishOnboarding() {
      this.api
        .finishOnboarding({
          data: {
            completed: true,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.completedAt) {
            this.$debug("Онбординг завершен", "success", response.data);
            this.getUserInfo();
          } else {
            throw response.data;
          }
        })
        .catch((error) => {
          this.$debug("Ошибка завершения онбординга", "error", error);
        });
    },
    onResize() {
      this.$store.dispatch("updateWindowWidth", window.innerWidth);
    },
    bodyClick() {
      clearTimeout(this.bodyclick_timeout);
      this.$store.dispatch("updateBodyClick", true);
      this.bodyclick_timeout = setTimeout(() => {
        this.$store.dispatch("updateBodyClick", false);
      }, 1000);
    },
    startUserUpdate() {
      clearInterval(this.user_update_interval);
      if (this.token) {
        this.user_update_interval = setInterval(() => {
          this.$debug("Автообновление данных юзера");
          this.getUserInfo();
        }, 30000);
      }
    },
    disablePreloader() {
      this.postGlobalLoading = false;
      setTimeout(() => {
        this.globalLoading = false;
      }, 500);
    },
    getUserInfo() {
      const app = this.agent
        ? {
            app: "app",
          }
        : {};
      return this.api
        .userInfo()
        .then((response) => {
          this.$debug(
            "Успешно выгружены данные юзера",
            "success",
            response.data
          );

          //MOCK не принял соглашение
          // response.data.userAgreementAcceptedAt = false;

          // response.data.phone = null;
          // response.data.email = null;

          const splitFullname = response.data.fullName?.split
            ? response.data?.fullName?.replace("  ", "").split(" ")
            : [];

          response.data.first_name = splitFullname[1];
          response.data.last_name = splitFullname[0];
          response.data.middle_name = splitFullname[2];

          this.$store.dispatch("updateUser", response.data);

          if (
            !this.user.userAgreementAcceptedAt &&
            this.$route.path !== "/user/agreement"
          ) {
            this.$router.push("/user/agreement");
          }
          this.getUserSubscription();
        })
        .catch((error) => {
          const params = {
            auth: "guest",
            MAX_TEXTURES_SIZE: this.MAX_TEXTURES_SIZE,
            ...app,
          };

          window.ym(process.env.VUE_APP_YA_METRIC, "params", params);

          this.$debug(
            `YA METRICS: передана инфа по guest, счетчик: ${process.env.VUE_APP_YA_METRIC}`
          );
          const error_message = error.message;
          this.$debug("Ошибка выгрузки данных юзера", "error", error);

          if (
            this.token &&
            (error_message === "Request failed with status code 400" ||
              error_message.indexOf("403") !== -1 ||
              this.globalLoading)
          ) {
            this.$store.dispatch("logoutUser");
          }

          this.$store.dispatch("resetUser");
          this.getSubs();
        })
        .finally(() => {
          this.disablePreloader();
        });
    },
  },
};
</script>
